import { SubtitlesCodec } from './enums/subtitles-codec';
import { StreamType } from '../stream/enums/stream-type';
import { HdrType } from './enums/hdr-type';
import { isApple } from '../clients/device-detection';
const detectSupportedCodecs = () => {
    const mimeTypes = {
        MP4: 'video/mp4',
        WEBM: 'video/webm',
    };
    const mp4VideoCodecs = [
        'avc1.4d402a',
        'hev1.1.6.L153.90',
    ];
    const mp4AudioCodecs = [
        'mp4a.40.2',
        'ec-3',
    ];
    const webmVideoCodecs = [
        'vp8',
        'vp9',
    ];
    const webmAudioCodecs = [
        'vorbis',
        'opus',
    ];
    const testVideoTypes = [
        ...mp4VideoCodecs.map((codec) => ({
            codec,
            type: `${mimeTypes.MP4};codecs="${codec}"`,
        })),
        ...webmVideoCodecs.map((codec) => ({
            codec,
            type: `${mimeTypes.WEBM};codecs="${codec}"`,
        })),
    ];
    const testAudioTypes = [
        ...mp4AudioCodecs.map((codec) => ({
            codec,
            type: `${mimeTypes.MP4};codecs="${codec}"`,
        })),
        ...webmAudioCodecs.map((codec) => ({
            codec,
            type: `${mimeTypes.WEBM};codecs="${codec}"`,
        })),
    ];
    const isSupportedVideo = testVideoTypes.map((type) => {
        if (MediaSource.isTypeSupported(type.type)) {
            return type.codec;
        }
        return false;
    }).filter(Boolean);
    const isSupportedAudio = testAudioTypes.map((type) => {
        // tests media source, not video element
        if (MediaSource.isTypeSupported(type.type)) {
            return type.codec;
        }
        return false;
    }).filter(Boolean);
    return {
        video: isSupportedVideo,
        audio: isSupportedAudio,
    };
};
// ToDo: implement using proper browser APIs or client detection
const detectSupportedStreamType = () => {
    if (isApple) {
        return [{
                type: StreamType.HLS7,
            }, {
                type: StreamType.HLS7_FAIRPLAY,
            }];
    }
    return [{
            type: StreamType.DASH,
        }, {
            type: StreamType.DASH_WIDEVINE,
            maxSecurityLevel: 'L3',
        }];
};
export const getWebDeviceCapabilities = () => {
    const supportedCodecs = detectSupportedCodecs();
    return Promise.resolve({
        streamTypeInformation: detectSupportedStreamType(),
        audioCodecs: supportedCodecs.audio,
        videoCodecs: supportedCodecs.video,
        subtitlesCodecs: [SubtitlesCodec.TTML, SubtitlesCodec.VTT],
    });
};
let _resolveWaiters = [];
let _deviceCapabilities;
/**
 * Updates the device capabilities used by the SDK, allowing platform specific overrides.
 */
export const updateDeviceCapabilities = (deviceCapabilities) => {
    const resolvers = _resolveWaiters.slice();
    _resolveWaiters = [];
    _deviceCapabilities = deviceCapabilities;
    _deviceCapabilities.then((capabilities) => {
        resolvers.forEach(({ resolve }) => resolve(capabilities));
    }).catch((error) => {
        resolvers.forEach(({ reject }) => reject(error));
    });
};
export const getDeviceCapabilities = () => {
    if (_deviceCapabilities) {
        return _deviceCapabilities;
    }
    return new Promise((resolve, reject) => {
        _resolveWaiters.push({
            resolve,
            reject,
        });
    });
};
export { HdrType, SubtitlesCodec, };
